import React from 'react';
import { CheckCircle2 } from 'lucide-react';
import { ScrollReveal } from './useScrollReveal';
export function TomosSection() {
  const tomos = [{
    emoji: '📘',
    title: 'Tomo 1 — El Espejo',
    subtitle: 'Reconocerse y nombrarse emocionalmente',
    desc: 'El adolescente aprende a identificar qué siente, por qué lo siente y cómo ponerle nombre. El primer paso para gestionar cualquier emoción.',
    color: 'from-blue-500/20 to-blue-900/20',
    border: 'border-blue-500/30'
  }, {
    emoji: '📙',
    title: 'Tomo 2 — El Volcán',
    subtitle: 'Identificar el enojo antes de explotar',
    desc: 'Herramientas para reconocer las señales del enojo, frenar la reacción impulsiva y canalizar la energía sin destruir vínculos.',
    color: 'from-red-500/20 to-orange-900/20',
    border: 'border-red-500/30'
  }, {
    emoji: '📗',
    title: 'Tomo 3 — El Escudo',
    subtitle: 'Recursos internos de protección emocional',
    desc: 'Desarrolla la capacidad de protegerse emocionalmente frente a presión social, bullying, redes sociales y situaciones que desbordan.',
    color: 'from-emerald-500/20 to-green-900/20',
    border: 'border-emerald-500/30'
  }, {
    emoji: '📕',
    title: 'Tomo 4 — El Timón',
    subtitle: 'Tomar decisiones con calma y propósito',
    desc: 'Aprende a pausar, evaluar opciones y elegir con claridad en lugar de reaccionar por impulso o presión.',
    color: 'from-purple-500/20 to-fuchsia-900/20',
    border: 'border-purple-500/30'
  }, {
    emoji: '📓',
    title: 'Tomo 5 — El Puente',
    subtitle: 'Reconstruir vínculos y comunicarse con adultos',
    desc: 'El tomo que reconstruye la conexión. Herramientas para que el adolescente aprenda a expresarse y el adulto aprenda a escuchar diferente.',
    color: 'from-rose-500/20 to-pink-900/20',
    border: 'border-rose-500/30'
  }, {
    emoji: '📔',
    title: 'Tomo 6 — El Mapa',
    subtitle: 'Plan de bienestar emocional personal',
    desc: 'El adolescente crea su propio plan de bienestar: rutinas, recursos, personas de confianza y estrategias personalizadas.',
    color: 'from-amber-500/20 to-yellow-900/20',
    border: 'border-amber-500/30'
  }];
  const includes = ['Actividades prácticas listas para usar', 'Ejercicios guiados paso a paso', 'Lenguaje adaptado a adolescentes de 12 a 18 años', 'Recursos para usar en casa, aula o consultorio', 'Herramientas de aplicación inmediata', 'Diseñado para funcionar sin formación previa en psicología', 'Compatible con procesos terapéuticos en curso', 'Material imprimible y digital'];
  return <section className="py-24 px-4 sm:px-6 lg:px-8 bg-navy-800" data-id="element-292">
      <div className="max-w-7xl mx-auto" data-id="element-293">
        {/* Section Header */}
        <ScrollReveal direction="up" className="text-center mb-16" data-id="element-294">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-cosmic-500/20 text-cosmic-400 mb-6 text-3xl shadow-[0_0_30px_rgba(168,85,247,0.3)]" data-id="element-295">
            ✨
          </div>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-4" data-id="element-296">
            MEGAPACK MI ESPACIO INTERIOR
          </h2>
          <p className="text-xl text-cosmic-300 font-medium mb-2" data-id="element-297">
            6 Tomos + 6 Bonos — El Sistema Completo de Gestión Emocional
            Adolescente
          </p>
          <p className="text-lg text-slate-400" data-id="element-298">
            Para adolescentes de 12 a 18 años · +500 páginas · Todo resuelto.
          </p>
        </ScrollReveal>

        <div className="text-center mb-12" data-id="element-299">
          <h3 className="text-2xl font-bold text-white" data-id="element-300">
            📚 6 TOMOS PRINCIPALES
          </h3>
        </div>

        {/* Tomo Cards */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mb-16" data-id="element-301">
          {tomos.map((tomo, index) => <ScrollReveal key={index} direction="up" delay={index % 3 + 1} className={`bg-gradient-to-b ${tomo.color} border ${tomo.border} rounded-2xl p-6 backdrop-blur-sm hover:scale-[1.02] transition-transform duration-300`} data-id="element-302">
              <div className="text-4xl mb-4 drop-shadow-md" data-id="element-303">{tomo.emoji}</div>
              <h4 className="text-xl font-bold text-white mb-1" data-id="element-304">
                {tomo.title}
              </h4>
              <p className="text-sm font-semibold text-slate-300 mb-4 pb-4 border-b border-white/10" data-id="element-305">
                {tomo.subtitle}
              </p>
              <p className="text-slate-300 text-sm leading-relaxed" data-id="element-306">
                {tomo.desc}
              </p>
            </ScrollReveal>)}
        </div>

        {/* Cada tomo incluye */}
        <ScrollReveal direction="up" className="bg-navy-900 border border-cosmic-500/30 rounded-2xl p-6 md:p-12 max-w-4xl mx-auto shadow-[0_0_40px_rgba(168,85,247,0.1)]" data-id="element-307">
          <h4 className="text-2xl font-bold text-center mb-8 text-transparent bg-clip-text bg-gradient-to-r from-white to-cosmic-200" data-id="element-308">
            Cada tomo incluye:
          </h4>
          <div className="grid md:grid-cols-2 gap-4" data-id="element-309">
            {includes.map((item, index) => <div key={index} className="flex items-start gap-3" data-id="element-310">
                <CheckCircle2 className="w-5 h-5 text-cosmic-400 flex-shrink-0 mt-0.5" data-id="element-311" />
                <span className="text-slate-300" data-id="element-312">{item}</span>
              </div>)}
          </div>
        </ScrollReveal>
      </div>
    </section>;
}